//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { encrypt } from '@/utils/Crypto'
import { isTrialAccount, TRIAL_PROFILE_LOCKED_TIP } from '@/utils/trialAccess'

export default {
  name: 'ChangePassword',
  data () {
    return {
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordType: 'password',
      inputFocus: [false, false, false],
      isFormValid: false,
      submitting: false,
      errorTips: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showStrengthBar: false,
      strengthLevel: 0,
      strengthText: '未设置',
      profileLocked: isTrialAccount()
    }
  },
  created () {
    if (this.profileLocked) {
      this.$toast(TRIAL_PROFILE_LOCKED_TIP)
      this.$router.replace('/profileEdit')
    }
  },
  watch: {
    'passwordForm.newPassword' (val) {
      this.validateForm()
      if (val) {
        this.showStrengthBar = true
        this.checkPasswordStrength(val)
      } else {
        this.showStrengthBar = false
        this.strengthLevel = 0
        this.strengthText = '未设置'
      }
    },
    'passwordForm.oldPassword' () {
      this.validateForm()
    },
    'passwordForm.confirmPassword' () {
      this.validateForm()
    }
  },
  methods: {
    togglePasswordVisibility () {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    onInputFocus (index) {
      this.inputFocus = this.inputFocus.map((_, i) => i === index)
      const fieldMap = ['oldPassword', 'newPassword', 'confirmPassword']
      this.errorTips[fieldMap[index]] = ''
    },
    onInputBlur (index) {
      this.inputFocus[index] = false
      this.validateForm()
    },
    validateForm () {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm
      let isValid = true
      const tips = { oldPassword: '', newPassword: '', confirmPassword: '' }

      if (!oldPassword) {
        tips.oldPassword = '请输入原密码'
        isValid = false
      } else if (oldPassword.length < 8) {
        tips.oldPassword = '原密码长度不能少于8位'
        isValid = false
      }

      if (!newPassword) {
        tips.newPassword = '请设置新密码'
        isValid = false
      } else if (newPassword.length < 8 || newPassword.length > 20) {
        tips.newPassword = '新密码长度必须为8-20位'
        isValid = false
      } else if (newPassword === oldPassword) {
        tips.newPassword = '新密码不能与原密码相同'
        isValid = false
      }

      if (!confirmPassword) {
        tips.confirmPassword = '请确认新密码'
        isValid = false
      } else if (confirmPassword !== newPassword) {
        tips.confirmPassword = '两次输入的密码不一致'
        isValid = false
      }

      this.errorTips = tips
      this.isFormValid = isValid
    },
    checkPasswordStrength (password) {
      let level = 0
      if (password.length >= 8) level++
      if (/[A-Z]/.test(password) && /[a-z]/.test(password)) level++
      if (/[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password)) level++
      this.strengthLevel = Math.min(level, 3)
      const texts = ['未设置', '弱', '中', '强']
      this.strengthText = texts[this.strengthLevel] || '未设置'
    },
    getLevelColor (level) {
      return ['#ff4d4f', '#faad14', '#52c41a'][level - 1] || '#e5e5e5'
    },
    submitChangePassword () {
      if (this.profileLocked || isTrialAccount()) {
        this.$toast(TRIAL_PROFILE_LOCKED_TIP)
        return
      }
      this.validateForm()
      if (!this.isFormValid) return

      this.submitting = true
      const encryptedData = {
        oldPassword: encrypt(this.passwordForm.oldPassword),
        newPassword: encrypt(this.passwordForm.newPassword)
      }

      this.$ajax
        .post(this.$api.getwordName, encryptedData)
        .then(() => {
          this.$toast('密码修改成功')
          setTimeout(() => this.$router.back(), 1500)
        })
        .catch(err => {
          const msg = (err && err.message) || ''
          if (msg.includes('原密码') || msg.includes('旧密码')) {
            this.errorTips.oldPassword = msg
          } else {
            this.$toast(msg || '修改失败，请重试')
          }
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/sys/updatePassword.vue